import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.onPageShow = (e) => {
      const hasReauth = document.cookie
        .split(";")
        .map((s) => s.trim())
        .some((c) => c.startsWith("reauth="));

      if (e.persisted && !hasReauth) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", this.onPageShow);
  }

  disconnect() {
    window.removeEventListener("pageshow", this.onPageShow);
  }
}
